function hasFeatureAccess(key) {
    const features = JSON.parse(localStorage.getItem('features')) || [];
    return features.includes(key);
}

export default hasFeatureAccess;